import React from 'react';
import { FaFileCircleCheck, FaFileCircleExclamation } from 'react-icons/fa6';

const DocumentCard = ({ title, document, isUpload, files, handleFileChange }) => {
    return (
        <div className='mb-3' key={document.id}>
            <div className="bg-white text-start border rounded-lg shadow p-4 flex flex-col justify-between items-start gap-2 mb-4">
                {!isUpload ?
                    <div className='flex items-center gap-2'>
                        <FaFileCircleExclamation size={30} />
                        <h3 className={`text-lg font-semibold`}>{title}</h3>
                    </div>
                    :
                    <div className='flex items-center gap-2'>
                        <FaFileCircleCheck size={30} className='text-p-green' />
                        <h3 className={`text-lg font-semibold text-blue-500`}>{title}</h3>
                    </div>
                }
                {!isUpload ?
                    <>
                        <input
                            type="file"
                            name={document.id}
                            accept=".pdf,.jpg,.png"
                            onChange={handleFileChange}
                            className="cursor-pointer w-full focus:outline-none focus:ring-2 focus:ring-blue-400 file:bg-blue-50 file:border file:mr-3 file:py-1 file:px-3 file:rounded-md file:text-sm file:font-medium file:text-blue-700"
                        />
                        {files[document.id] && (
                            <p className="text-sm text-gray-600 mt-1">
                                Archivo cargado: {files[document.id].name}
                            </p>
                        )}
                    </>
                    : ""
                }
            </div>
        </div>
    );
};

export default DocumentCard;